/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { ID } from '@gh/common-shared-data';
import { createEnum, EnumSet, WithOptimisticLock } from '@gh/core-data';

export const LETTER_TEMPLATE_SYSTEM_TYPE = 'System';
export const LETTER_TEMPLATE_JOB_TYPE = 'Job';

export const LetterTemplateType = createEnum('LETTER_TEMPLATES', {
  System: 'SYSTEM',
  Job: 'JOB',
});

export type LetterTemplateType = EnumSet<typeof LetterTemplateType>;

export const LetterTemplateLevel = createEnum('LETTER_TEMPLATE_LEVEL', {
  Corporate: 'CORPORATE',
  Master: 'MASTER',
  Office: 'OFFICE',
});

export type LetterTemplateLevel = EnumSet<typeof LetterTemplateLevel>;

export const GSuiteFolderType = createEnum('GSUITE_FOLDER_TYPE', {
  CorporateTemplates: 'CORPORATE_TEMPLATES',
  MasterZoneTemplatesDraft: 'MASTER_ZONE_TEMPLATES_DRAFT',
  MasterZoneTemplates: 'MASTER_ZONE_TEMPLATES',
  OfficeTemplatesDraft: 'OFFICE_TEMPLATES_DRAFT',
  OfficeTemplates: 'OFFICE_TEMPLATES',
});

export type GSuiteFolderType = EnumSet<typeof GSuiteFolderType>;

export type LetterTemplateDto = WithOptimisticLock<{
  fileName: string;
  fileExtension: string;
  type: LetterTemplateType;
  draftFileId?: ID;
  corporateFileId?: ID;
  masterFileId?: ID;
  officeFileId?: ID;
  draftDocUrl?: string;
}>;

export type LetterTemplateSourceDto = WithOptimisticLock<{
  id: ID;
  fileName: string;
  fileExtension: string;
  type: LetterTemplateType;
}>;

export type LetterTemplateCopyDto = WithOptimisticLock<{
  template: LetterTemplateSourceDto;
  direction?: GSuiteFolderType;
}>;

export type LetterTemplateValidationResultDto = {
  incorrectFormat: string[];
  missingInDb: string[];
  parsingFailed: string[];
  unavailableForTemplate: string[];
};
